import * as React from 'react';

export const Loading = props => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.30937 12.5637L3.87437 13.9987C3.54937 14.3245 3.54937 14.852 3.87437 15.177C4.0377 15.3404 4.2502 15.4212 4.46353 15.4212C4.67687 15.4212 4.8902 15.3404 5.0527 15.177L6.4877 13.742C6.81353 13.4162 6.81353 12.8887 6.4877 12.5637C6.16187 12.2379 5.6352 12.2379 5.30937 12.5637Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2252 12.5637C13.8994 12.2379 13.3727 12.2379 13.0469 12.5637C12.721 12.8887 12.721 13.4162 13.0469 13.742L14.4819 15.177C14.6444 15.3404 14.8577 15.4212 15.071 15.4212C15.2844 15.4212 15.4969 15.3404 15.6602 15.177C15.9852 14.852 15.9852 14.3245 15.6602 13.9987L14.2252 12.5637Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.76717 13.9224C9.30634 13.9224 8.93384 14.2957 8.93384 14.7557V16.784C8.93384 17.244 9.30634 17.6174 9.76717 17.6174C10.228 17.6174 10.6005 17.244 10.6005 16.784V14.7557C10.6005 14.2957 10.228 13.9224 9.76717 13.9224Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.30912 6.5398L3.87412 5.1048C3.54912 4.77897 3.54912 4.25147 3.87412 3.92647C4.03745 3.76314 4.24995 3.6823 4.46329 3.6823C4.67662 3.6823 4.88995 3.76314 5.05245 3.92647L6.48745 5.36147C6.81329 5.68731 6.81329 6.2148 6.48745 6.5398C6.16162 6.86564 5.63495 6.86564 5.30912 6.5398Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2252 6.5398C13.8994 6.86564 13.3727 6.86564 13.0469 6.5398C12.721 6.2148 12.721 5.68731 13.0469 5.36147L14.4819 3.92647C14.6444 3.76314 14.8577 3.6823 15.071 3.6823C15.2844 3.6823 15.4969 3.76314 15.6602 3.92647C15.9852 4.25147 15.9852 4.77897 15.6602 5.1048L14.2252 6.5398Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.76717 5.18115C9.30634 5.18115 8.93384 4.80782 8.93384 4.34782V2.31949C8.93384 1.85949 9.30634 1.48615 9.76717 1.48615C10.228 1.48615 10.6005 1.85949 10.6005 2.31949V4.34782C10.6005 4.80782 10.228 5.18115 9.76717 5.18115Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2672 8.45068H15.2389C14.7789 8.45068 14.4055 8.82402 14.4055 9.28402C14.4055 9.74402 14.7789 10.1174 15.2389 10.1174H17.2672C17.728 10.1174 18.1005 9.74402 18.1005 9.28402C18.1005 8.82402 17.728 8.45068 17.2672 8.45068Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.12858 9.28402C5.12858 8.82402 4.75608 8.45068 4.29525 8.45068H2.73275C2.27191 8.45068 1.89941 8.82402 1.89941 9.28402C1.89941 9.74402 2.27191 10.1174 2.73275 10.1174H4.29525C4.75608 10.1174 5.12858 9.74402 5.12858 9.28402Z"
      fill="#64748B"
    />
  </svg>
);
